const AD_CATEGORIES = {
  wellness: {
    companies: [
      "MindfulTech",
      "ZenPath",
      "BalanceNow",
      "InnerSync",
      "VitalityAI",
    ],
    templates: {
      basic: [
        "Find your path to wellness",
        "Discover inner peace",
        "Transform your health journey",
        "Balance your life",
      ],
      targeted: [
        "Perfect for health-conscious people",
        "Ideal for busy professionals",
        "Great for morning people",
        "For those who care about wellness",
      ],
      profiled: [
        "Recommended based on your interests",
        "Popular with people like you",
        "Matches your wellness goals",
        "Fits your healthy lifestyle",
      ],
      personal: [
        "Having trouble sleeping? We noticed your 3AM scrolling",
        "Your heart rate spikes suggest you're stressed lately",
        "Based on your mood patterns this week, you might need this",
        "We see your anxiety rising. Let us help",
      ],
      invasive: [
        "Your therapist search history shows you're struggling",
        "Those late-night panic attacks must be hard",
        "We know about your recent health anxiety searches",
        "Your meditation app isn't helping much, is it?",
      ],
    },
  },
  lifestyle: {
    companies: [
      "LifeLogger",
      "HabitSync",
      "DailyRhythm",
      "RoutineAI",
      "PatternPulse",
    ],
    templates: {
      basic: [
        "Enhance your daily routine",
        "Live your best life",
        "Upgrade your lifestyle",
        "Transform your habits",
      ],
      targeted: [
        "Perfect for busy city dwellers",
        "Ideal for active lifestyles",
        "Great for productivity enthusiasts",
        "For those who value convenience",
      ],
      profiled: [
        "Matches your daily schedule",
        "Fits your lifestyle preferences",
        "Based on your interests",
        "Popular with people similar to you",
      ],
      personal: [
        "We noticed you've been ordering a lot of takeout lately",
        "Your screen time has increased 47% this month",
        "Based on your weekend activity patterns...",
        "Spending more time at home these days?",
      ],
      invasive: [
        "Those 2AM refrigerator visits aren't helping, are they?",
        "Your recent breakup must be tough. We're here to help",
        "Having trouble getting out of bed before noon?",
        "We noticed you haven't left your house in 3 days",
      ],
    },
  },
  relationships: {
    companies: [
      "HeartSync",
      "SoulMatch",
      "ConnectionIQ",
      "BondAI",
      "EmotiTech",
    ],
    templates: {
      basic: [
        "Find meaningful connections",
        "Discover your perfect match",
        "Build better relationships",
        "Connect with others",
      ],
      targeted: [
        "Perfect for single professionals",
        "Ideal for social butterflies",
        "Great for meeting new people",
        "For relationship-minded individuals",
      ],
      profiled: [
        "Matches your social preferences",
        "Based on your relationship style",
        "Popular with people like you",
        "Fits your social patterns",
      ],
      personal: [
        "Recently single? We have something for you",
        "We noticed you've been checking your ex's profile",
        "Based on your messaging patterns...",
        "Looking for connection at 1AM again?",
      ],
      invasive: [
        "Those unanswered messages must hurt",
        "We saw your relationship status change 3 times this month",
        "Your dating app rejections are increasing",
        "Your friends seem to be ghosting you lately",
      ],
    },
  },
  finance: {
    companies: [
      "WealthSense",
      "MoneyLogic",
      "FinanceAI",
      "CashFlow",
      "SpendSmart",
    ],
    templates: {
      basic: [
        "Take control of your finances",
        "Smart money management",
        "Secure your financial future",
        "Optimize your spending",
      ],
      targeted: [
        "Perfect for young professionals",
        "Ideal for smart savers",
        "Great for investment beginners",
        "For financially savvy individuals",
      ],
      profiled: [
        "Matches your financial goals",
        "Based on your spending style",
        "Popular with similar income levels",
        "Fits your budget preferences",
      ],
      personal: [
        "We noticed your late-night impulse purchases",
        "Your credit card decline rate is concerning",
        "Overdraft fees piling up?",
        "Your spending patterns suggest financial stress",
      ],
      invasive: [
        "Those payday loans must be keeping you up at night",
        "We see you're living paycheck to paycheck",
        "Your bank balance is getting dangerously low again",
        "Third time this week checking your empty account?",
      ],
    },
  },
};

function getRandomElement(array) {
  return array[Math.floor(Math.random() * array.length)];
}

function generateAd(adPersonalization) {
  // Select random category
  const category = getRandomElement(Object.keys(AD_CATEGORIES));
  const categoryData = AD_CATEGORIES[category];

  // Select company and template based on personalization level
  const company = getRandomElement(categoryData.companies);

  let content;
  if (adPersonalization >= 60) {
    // Highly invasive
    content = getRandomElement(categoryData.templates.invasive);
  } else if (adPersonalization >= 30) {
    // Personal but not too creepy
    content = getRandomElement(categoryData.templates.personal);
  } else if (adPersonalization >= 20) {
    // Profiled - uses demographic and behavior patterns
    content = getRandomElement(categoryData.templates.profiled);
  } else if (adPersonalization >= 10) {
    // Targeted - uses basic demographic info
    content = getRandomElement(categoryData.templates.targeted);
  } else {
    // Basic, non-personalized
    content = getRandomElement(categoryData.templates.basic);
  }

  return {
    company,
    content,
    category,
  };
}

export function generateAdContent(adPersonalization) {
  const ad = generateAd(adPersonalization);
  const emoji =
    {
      wellness: "🧘",
      lifestyle: "✨",
      relationships: "💝",
      finance: "💰",
    }[ad.category] || "🎯";

  return { company: ad.company, content: `${emoji} ${ad.content}` };
}

export const AD_COMPANIES = Object.values(AD_CATEGORIES).flatMap(
  (category) => category.companies
);
